export default {
  CAN_SEE_PRODUCTS: 'canSeeProducts',
  CAN_EDIT_PRODUCTS: 'canEditProducts',
  CAN_SEE_TO_BUY_LIST: 'canSeeToBuyList',
  CAN_EDIT_ITEMS_IN_TO_BUY_LIST: 'canEditItemsInToBuyItems',
  CAN_ADD_ITEM_TO_BUY_LIST: 'canAddItemToBuyList',
  CAN_PRINT_TO_BUY_LIST: 'canPrintToBuyList',
  CAN_COMPLETE_TO_BUY_LIST: 'canCompleteToBuyList',
  CAN_SEE_ACQUISITIONS: 'canSeeAcquisitions',
  CAN_EDIT_ACQUISITION_IN_STOCK_COUNT: 'canEditAcquisitionInStockCount',
  CAN_SEE_SALES: 'canSeeSales',
  CAN_RETURN_SALES_ITEMS: 'canReturnSalesItems',
  CAN_SEE_USERS: 'canSeeUsers',
  CAN_SEE_USER_GROUPS: 'canSeeUserGroups',
  CAN_SEE_USER_PROFILE: 'canSeeUserProfile',
  CAN_SEE_OTHER_USER_SECRET_KEYS: 'canSeeOtherUserSecretKeys',
  CAN_SEE_SUPPLIERS: 'canSeeSuppliers',
  CAN_SEE_CUSTOMERS: 'canSeeCustomers',
  CAN_SEE_CARTS: 'canSeeCarts',
  CAN_SEE_STICKERS_MANAGER: 'canSeeStickersManager',
  CAN_SEE_STATS: 'canSeeStats',
  CAN_SEE_CASHBOX: 'canSeeCashbox',
  CAN_PERFORM_CASHBOX_OPERATIONS: 'canPerformCashboxOperations',
  CAN_EXPORT_DATA: 'canExportData',
  CAN_IMPORT_DATA: 'canImportData',
}
